import { processSerializedThreeSixties } from '../../../Components/VirtualTour/VirtualTourDetailNormalizeData';
import { finishCollectionNormalizeData } from '../../../Components/FinishCollection/FinishCollectionNormalizeData';
import { includedPhotoGalleryImagesNormalizedData } from '../../../Components/PhotoGallery/IncludedPhotoGalleryImagesNormalizedData';
import { processFeeGroups } from '../../feeUtils';

const FloorPlanNormalizedDataCore = ( deserializedData, included ) => {
  const {
    field2dFloorPlan,
    field3dFloorPlan,
    fieldBathrooms,
    fieldBedrooms,
    fieldDescription,
    fieldDownloadablePdf,
    fieldFeeGroups,
    fieldFinishCollection,
    fieldFloorPlanCategory,
    fieldFurnitureConfiguratorUrl,
    fieldKeyColor,
    fieldLevelOfCare,
    fieldPhotoGallery,
    fieldRooms,
    fieldSquareFootage,
    fieldStudio,
    fieldVideo,
    fieldVirtualTour,
    fieldWithDen,
    id,
    title,
  } = deserializedData;

  // 2d floor plan
  let twoDFloorPlan = null;
  const twoDFpFieldId = field2dFloorPlan?.id;
  if ( twoDFpFieldId ) {
    const twoDFpFieldData = included.find( ( include ) => include.id === twoDFpFieldId );
    twoDFloorPlan = {
      oneThirdScreen: twoDFpFieldData?.links?.one_third_screen?.href,
      modal: twoDFpFieldData?.links?.modal?.href,
    };
  }

  // 3d floor plan
  let threeDFloorPlan = null;
  const threeDFpFieldId = field3dFloorPlan?.id;
  if ( threeDFpFieldId ) {
    const threeDFpFieldData = included.find(
      ( include ) => include.id === threeDFpFieldId,
    );
    threeDFloorPlan = {
      oneThirdScreen: threeDFpFieldData?.links?.one_third_screen?.href,
      modal: threeDFpFieldData?.links?.modal?.href,
    };
  }

  // Save fees into specific data structure.
  let fees = [];
  let feePlanMap = null;
  let hasFeePlanNames = false;

  if ( fieldFeeGroups.length > 0 ) {
    // Use processFeeGroups to handle all fee groups in a consistent way
    const feeData = processFeeGroups( fieldFeeGroups, [] );
    fees = feeData.feeDisplays;
    feePlanMap = feeData.planMap;
    hasFeePlanNames = feeData.hasFeePlanNames;
  }

  const roomData = fieldRooms.map( ( roomDatum ) => ( {
    label: roomDatum.name,
    data: roomDatum.dimensions,
  } ) );

  // virtual tour
  const threeSixtiesData = fieldVirtualTour?.fieldThreeSixties;
  const threeSixties = processSerializedThreeSixties( threeSixtiesData );

  // finish collection
  const finishCollection = finishCollectionNormalizeData(
    fieldFinishCollection?.fieldFinishOption,
    included,
  );

  // furniture configurator
  const furnitureConfiguratorUrl = fieldFurnitureConfiguratorUrl?.uri;

  // video
  let video = null;
  if ( fieldVideo?.fieldVideoId && fieldVideo?.fieldVideoService ) {
    video = {
      videoId: fieldVideo.fieldVideoId,
      service: fieldVideo.fieldVideoService,
      autoplay: false,
    };
  }

  // photo gallery
  const includedIndex = included?.findIndex(
    ( include ) => include.id === fieldPhotoGallery?.id,
  );
  const photoGalleryImages = includedPhotoGalleryImagesNormalizedData(
    fieldPhotoGallery?.fieldGalleryPhotos,
    includedIndex,
    included,
  );

  // If the floor plan has Den, Show it in details.
  let withDen = 'No';
  if ( fieldWithDen ) {
    withDen = 'Yes';
  }

  // Downloadable PDF.
  let downloadablePdfPath = null;
  const fpPdfFieldId = fieldDownloadablePdf?.id;
  if ( fpPdfFieldId ) {
    const cmsUrl = process.env.REACT_APP_YOUR_TOUR_CMS_URL;
    const fpPdfFieldData = included.find(
      ( include ) => include.id === fpPdfFieldId,
    );

    const rawPdfPath = fpPdfFieldData?.attributes?.uri?.url;
    downloadablePdfPath = rawPdfPath ? `${cmsUrl}${rawPdfPath}` : null;
  }

  return {
    title,
    bath: fieldBathrooms,
    bed: fieldBedrooms,
    description: fieldDescription,
    downloadablePdf: downloadablePdfPath,
    finishCollection,
    floorPlanCategoryId: fieldFloorPlanCategory?.id,
    floorPlanCategoryName: fieldFloorPlanCategory?.name,
    floorPlanCategoryWeight: fieldFloorPlanCategory?.weight,
    twoD: twoDFloorPlan,
    threeD: threeDFloorPlan,
    furnitureConfiguratorUrl,
    uuid: id,
    // We need id for now beacuse components are consistent yet on using uuid
    id,
    levelOfCareId: fieldLevelOfCare?.id,
    levelOfCareName: fieldLevelOfCare?.name,
    levelOfCareWeight: fieldLevelOfCare?.weight,
    levelOfCareIsDefault: fieldLevelOfCare?.fieldDefaultLevelOfCare,
    photoGalleryImages,
    roomData,
    fees,
    feePlanMap,
    hasFeePlanNames,
    sqft: fieldSquareFootage,
    studio: fieldStudio,
    threeSixties,
    video,
    withDen,
    keyColor: fieldKeyColor,
  };
};

export default FloorPlanNormalizedDataCore;
